import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import NavBar from '../components/_layouts/NavBar';
import {
  BlurredBackgroundImage,
  PrivateRouteWrapper,
  PublicRouteWrapper,
} from '../components/_layouts/global/styles';

const MyRoute = ({ component: Component, isPrivate = false, ...rest }) => {
  const token = useSelector((state) => state.auth.token);

  // Authenticated user trying to access sigin/signup page
  if (!isPrivate && token) {
    return (
      <Route
        {...rest}
        render={(props) => (
          <Redirect
            to={{
              pathname: '/home',
              state: { from: props.location },
            }}
          />
        )}
      />
    );
  }

  // Not authenticated user trying to access private route
  if (isPrivate && !token) {
    return (
      <Route
        {...rest}
        render={(props) => (
          <Redirect
            to={{
              pathname: '/signin',
              state: { from: props.location },
            }}
          />
        )}
      />
    );
  }

  // Public routes
  if (!isPrivate && !token) {
    return (
      <Route
        {...rest}
        render={(props) => (
          <>
            <BlurredBackgroundImage />
            <PublicRouteWrapper>
              <Component {...props} />
            </PublicRouteWrapper>
          </>
        )}
      />
    );
  }

  // Authenticated user in private route
  return (
    <Route
      {...rest}
      render={(props) => (
        <>
          <NavBar />
          <BlurredBackgroundImage />
          <PrivateRouteWrapper>
            <Component {...props} />
          </PrivateRouteWrapper>
        </>
      )}
    />
  );
};

export default MyRoute;

MyRoute.propTypes = {
  isPrivate: PropTypes.bool,
};

MyRoute.defaultProps = {
  isPrivate: false,
};
